import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

function LoadingData() {
  return (
    <div className="card">
      <div className="card-body d-flex flex-column justify-content-center align-items-center">
        <CircularProgress
          style={{ fontSize: "82px" }}
          className="text-secondary"
        />
        <span
          className="font-weight-bold mt-3 text-secondary"
          style={{ fontSize: "25px" }}
        >
          Loading data :(
        </span>
      </div>
    </div>
  );
}

export default LoadingData;
